export default __webpack_public_path__ + "static/media/1.a13eed06.png";